import { get, includes } from 'lodash'
// import get from 'lodash/get'
// import includes from 'lodash/includes'
import { AxiosInstance, AxiosRequestConfig, isAxiosError, Method } from 'axios'
import qs from 'qs'

export class BaseAPI {
  private axios: AxiosInstance

  constructor(axiosInstance: AxiosInstance) {
    this.axios = axiosInstance
  }

  async request<T>(route: string, method: Method, args?: Record<string, unknown> | unknown[], token?: string): Promise<T> {
    const requestConfig: AxiosRequestConfig = {
      url: route,
      method,
      headers: {
        'Content-Type': 'application/json',
      },
      paramsSerializer: {
        serialize: (params) => {
          return qs.stringify(params, { arrayFormat: 'brackets' })
        },
      },
    }
    if (includes(['POST', 'PUT', 'PATCH', 'DELETE'], method.toUpperCase())) {
      requestConfig.data = args
    } else {
      requestConfig.params = args
    }
    if (token) requestConfig.headers!.Authorization = `Bearer ${token}`
    try {
      const response = await this.axios<{ datas: T }>(requestConfig)
      return get(response.data, 'datas')
    } catch (error: unknown) {
      if (isAxiosError(error) && error.response) {
        console.error('API Error:', { status: error.response.status, data: error.response.data })
      } else if (error instanceof Error) {
        console.error('API Error:', error.message)
      }
      throw error
    }
  }
}
